import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EngagementModel } from '../models/engagement.model';
import { PreviewAttributeArrayModel } from '../models/previewAttributesArary.model';
import { UserModel } from '../models/user.model';
import { SourceFile } from '../models/sourceFile.model';
import { SourceFileTab } from '../models/SourceFileTab';
import { ScenarioResult } from '../models/scenarioResult.model';
import { EntityModel } from '../models/legalentity-model';
import { tap } from 'rxjs/operators';
import { InfraService } from './infra.service';
import { InfraEndPointModel } from '../models/infraEndPoint.model';
import { LanguageModel } from '../models/language.model';
import { MasterLanguage } from '../models/MasterLanguage.model';


@Injectable()
export class EngagementService {
  
  private pythonUrl: string;
  private coreAPIUrl: string;
  private coreAPIDownloadUploadUrl: string;
  private configCoreEngagementUrl: string;
  private infraDetails: InfraEndPointModel;
  private logOutCoreUrl: string;
  engModel: any;

  filesDataArray: PreviewAttributeArrayModel = new PreviewAttributeArrayModel();

  constructor(private infraService: InfraService, private http: HttpClient) {
    this.infraService.infraDetails$.subscribe((data: InfraEndPointModel) => {
      this.infraDetails = data;
      
      this.configCoreEngagementUrl = data.WebEndPoint2 + 'engagement';
      this.coreAPIUrl = data.WebEndPoint2 + 'PreviewAttribute';
      this.coreAPIDownloadUploadUrl = data.WebEndPoint2 + 'DownloadUploadFile';
      this.logOutCoreUrl = data.WebEndPoint2 + 'LogOut';
      

    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra')) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }
  }



  public getMyActiveEngagements(regionName: string): Observable<EngagementModel[]> {
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    if (isIEOrEdge) {
      return this.http.get<EngagementModel[]>(`${this.configCoreEngagementUrl}/getMyActiveEngagements/${regionName}`,
        {
          headers: new HttpHeaders({
            'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT', 'If-Modified-Since': '0'
          })
        });
    } else {
      return this.http.get<EngagementModel[]>(`${this.configCoreEngagementUrl}/getMyActiveEngagements/${regionName}`);
    }
  }

  public getMyEngagements(regionName: string): Observable<EngagementModel[]> {
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    if (isIEOrEdge) {
      return this.http.get<EngagementModel[]>(`${this.configCoreEngagementUrl}/getMyEngagements/${regionName}`,
        {
          headers: new HttpHeaders({
            'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT', 'If-Modified-Since': '0'
          })
        });
    } else {
      return this.http.get<EngagementModel[]>(`${this.configCoreEngagementUrl}/getMyEngagements/${regionName}`);
    }
  }

  public getClosedEngagements(regionName: string): Observable<EngagementModel[]> {
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    if (isIEOrEdge) {
      return this.http.get<EngagementModel[]>(`${this.configCoreEngagementUrl}/getClosedEngagements/${regionName}`,
        {
          headers: new HttpHeaders({
            'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT', 'If-Modified-Since': '0'
          })
        });
    } else {
      return this.http.get<EngagementModel[]>(`${this.configCoreEngagementUrl}/getClosedEngagements/${regionName}`);
    }
  }

  public getEngagement(engagementId: number): Observable<EngagementModel> {
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    if (isIEOrEdge) {
       return this.http.get<EngagementModel>(`${this.configCoreEngagementUrl}/getEngagement/${engagementId}`,
        {
          headers: new HttpHeaders({
            'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT', 'If-Modified-Since': '0'
          })
        });
    }
    else {
      return this.http.get<EngagementModel>(`${this.configCoreEngagementUrl}/getEngagement/${engagementId}`);
    }
  }


  public getEngagementUsers(engagementId: number): Observable<UserModel[]> {
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    if (isIEOrEdge) {
      return this.http.get<UserModel[]>(`${this.configCoreEngagementUrl}/GetEngagementUsers/${engagementId}`,
        {
          headers: new HttpHeaders({
            'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT', 'If-Modified-Since': '0'
          })
        });
    } else {
      return this.http.get<UserModel[]>(`${this.configCoreEngagementUrl}/GetEngagementUsers/${engagementId}`);
    }
  }

  public save(engagementData: EngagementModel) {
  
    return this.http.post(`${this.configCoreEngagementUrl}/CreateEngagement`,  engagementData);
  }

  public update(engagementData: EngagementModel) {
    return this.http.post(`${this.configCoreEngagementUrl}/UpdateEngagement/${engagementData.Id}`,  engagementData );
  }

  public updateEngagementStepId(engagementId: number, stepId: number) {

    return this.http.post(
      `${this.configCoreEngagementUrl}/UpdateEngagementStepId/${engagementId}/${stepId}`,
      {});

  }

  public updateEngagementFlatFileStepId(engagementId: number, engagementData: any) {
    return this.http.post(`${this.configCoreEngagementUrl}/updateEngagementFlatFileStepId/${engagementId}`, engagementData);

  }

  public closeEngagement(engagementId: number) {
    return this.http.post(`${this.configCoreEngagementUrl}/closeEngagement/${engagementId}`, {});
  }

  public reactivateClosedEngagement(engagementId: number) {
    return this.http.post(`${this.configCoreEngagementUrl}/reactivateClosedEngagement/${engagementId}`, {});
  }
  
  public deleteEngagement(engagementId: number, region:string | null) {
    return this.http.post(`${this.configCoreEngagementUrl}/deleteEngagement/${engagementId}/${region}`, {});
  }



  public getDataForScenarioAssesment(engagementId: number): Observable<ScenarioResult[]> {
    return this.http.get<ScenarioResult[]>(`${this.configCoreEngagementUrl}/getScenarioAssesment/${engagementId}`);
  }

 

  public getSourceFilesContent(sourceFileId: number) {

    const authHeader = (environment.isBearerAuthorizationEnabled ? localStorage['dbamsaltoken'] : environment.sampleToken);
    const xhr = new XMLHttpRequest();
    const url = `${this.configCoreEngagementUrl}/getSourceFilesContent/${sourceFileId}?m=${Math.random()}`;
    xhr.open('GET', url, true);
    xhr.setRequestHeader('Content-type', 'application/json');
    xhr.responseType = 'blob';
    xhr.setRequestHeader('Authorization', 'Bearer ' + authHeader);
    return xhr;
  }

  public getUploadedSourceFiles(engagementId: number) {
     return this.http.get<SourceFile[]>(`${this.coreAPIDownloadUploadUrl}/getSourceFileUploadDetails/${engagementId}`);
   
  }

  public getsourcefiletabdetails(engagementId: number) {
    return this.http.get<any>(`${this.coreAPIDownloadUploadUrl}/getsourcefiletabdetails/${engagementId}`);
  }

  public getFilesData(engagementId: number) {
   
    return this.http.get(`${this.coreAPIUrl}/getfilesdata/${engagementId}`);
  }

  public saveFilesData(filesDataArray: PreviewAttributeArrayModel) {
    return this.http.post(`${this.coreAPIUrl}/`, filesDataArray);
  }

  public getAllEntity(engagementId: number) {
    return this.http.get(`${this.coreAPIUrl}/getAllEntity/${engagementId}`);
  }

  public getAllPeriod(engagementId: number) {
    return this.http.get(`${this.configCoreEngagementUrl}/getAllPeriod/${engagementId}`);
  }

  public checkExistance(sourceId: number) {
    return this.http.get(`${this.coreAPIDownloadUploadUrl}/getCheckSourceFileDataExistance/${sourceId}`);
  }

  public deleteSourceFileData(sourceId: number, fileName: string, engagementId: number) {
    return this.http.post(`${this.coreAPIDownloadUploadUrl}/deleteSourceFileData`,
      { 'Id': sourceId, 'FileName': fileName, 'EngagementId': engagementId });
  }

  public deleteAllSourceFiles(engagementId: number) {
    return this.http.get(`${this.coreAPIDownloadUploadUrl}/deleteallsourcefiles/${engagementId}`);
  }

  public downloadSourceFileFromAzureStorage(sourceId: number, engagementId: number) {

    return this.http.get(`${this.coreAPIDownloadUploadUrl}/${engagementId}/${sourceId}`, {
      headers: new HttpHeaders({ 'Content-Type': 'application/octet-stream' }),
      responseType: 'blob'
    }).pipe(
      tap(
      )
    );

  }

  public downloadAllSourceFileFromAzureStorage(engagementId: number) {
    return this.http.get(`${this.coreAPIDownloadUploadUrl}/GetAllFiles/${engagementId}`, {
      headers: new HttpHeaders({ 'Content-Type': 'application/octet-stream' }),
      responseType: 'blob'
    }).pipe(
      tap(
      )
    );

  }



  public getProcessedTabSummary(id: number): Observable<{ FiscalYear: string, ProcessedMonths: number }[]> {
    return this.http.get<{ FiscalYear: string, ProcessedMonths: number }[]>(`${this.configCoreEngagementUrl}/getProcessedTabSummary/${id}`);
  }

  public GetEngagementFlatfileUploadedFlag(engagementId: number): Observable<{ engagementFlag: any }> {
    return this.http.get<{ engagementFlag: any }>(`${this.configCoreEngagementUrl}/GetEngagementFlatfileUploadedFlag/${engagementId}`);
  }

  public CheckUserAccessForEngagement(engagementId: number) {
    return this.http.get(`${this.configCoreEngagementUrl}/CheckUserAccessForEngagement/${engagementId}`);
  }

  public UpdateEngagementFlatfileUploaded(engagementId: number, flatFileName: string) {
    return this.http.post(`${this.configCoreEngagementUrl}/UpdateEngagementFlatfileUploaded/${engagementId}/${flatFileName}`, {});
  }

  public GetEngagementBasedOndaiseyProjectId(daiseyProjectId: any) {
    return this.http.get(`${this.configCoreEngagementUrl}/GetEngagementBasedOndaiseyProjectId/${daiseyProjectId}`);
  }

  public UpdateredirectToVerificationByEngagementId(engagementId: number, isredirectToVerification: boolean) {
    return this.http.post(
      `${this.configCoreEngagementUrl}/UpdateredirectToVerificationByEngagementId/${engagementId}/${isredirectToVerification}`,
      {});
  }

  public updateAuthenticationTokenDetails() {
    return this.http.post(`${this.logOutCoreUrl}/UpdateAuthenticationTokenDetails`, {});
  }

  public GetAllActiveLanguages() {
    return this.http.get<MasterLanguage[]>(`${this.configCoreEngagementUrl}/getAllActiveLanguages`);
  }
}
